// extracted by mini-css-extract-plugin
module.exports = {"phone":"TrackedPhoneNumber_phone___KpVL","placeholder":"TrackedPhoneNumber_placeholder__auKVL"};